import { Spin } from 'antd';

export default function LoadingBlock({ tip = 'Loading…', height = 200 }) {
  return (
    <div
      className="flex items-center justify-center w-full"
      style={{ minHeight: height }}
    >
      <Spin tip={tip}>
        <div className="min-w-[80px] min-h-[60px]" />
      </Spin>
    </div>
  );
}
